import PropTypes from 'prop-types';
import { Skeleton, Box, Typography } from '@mui/material';
import { AppChartCard } from '../@dashboard/app';

GridOutputChart.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  series: PropTypes.array,
  loading: PropTypes.bool,
  hasData: PropTypes.bool,
};

export default function GridOutputChart({
  startDate,
  endDate,
  series = [],
  loading = false,
  hasData = false,
}) {
  if (loading) {
    return (
      <Box sx={{ minHeight: 320 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.paper',
            boxShadow: 1,
          }}
        >
          <Skeleton variant="text" width="40%" height={32} />
          <Skeleton variant="text" width="15%" height={24} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={242} sx={{ borderRadius: 2 }} />
        </Box>
      </Box>
    );
  }

  if (!hasData) {
    return (
      <Box sx={{ minHeight: 320, textAlign: 'center', pt: 5 }}>
        <Typography variant="body2">No grid output data available.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <AppChartCard
        title="Grid Output"
        subheader="kW"
        chartData={series}
        xMinMs={startDate?.valueOf()}
        xMaxMs={endDate?.valueOf()}
      />
    </Box>
  );
}